"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideHotspotIcon = void 0;
var hideHotspotIcon = function hideHotspotIcon(icon) {
  icon.style.visibility = 'hidden';
  icon.style.opacity = 0;
};
exports.hideHotspotIcon = hideHotspotIcon;